import React, { useState, useEffect } from 'react';
import { Save, Zap, MousePointer2, Info, Clock, Star } from 'lucide-react';
import { useContract } from '../../hooks/useContract';
import { useGamePurchases } from '../../hooks/useGamePurchases';
import { GAME_CONFIG } from '../../config/game';
import toast from 'react-hot-toast';

interface PurchasesTabProps {
  inputClasses: string;
  currentWallet: string;
}

export function PurchasesTab({ inputClasses, currentWallet }: PurchasesTabProps) {
  const { updatePurchaseLimits, isDemoMode } = useContract();
  const { autoClickers = [] } = useGamePurchases(currentWallet);
  const [maxMultiplierPurchase, setMaxMultiplierPurchase] = useState(10);
  const [maxAutoClickerPurchase, setMaxAutoClickerPurchase] = useState(5);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await updatePurchaseLimits(maxMultiplierPurchase, maxAutoClickerPurchase);
      toast.success(isDemoMode ? 'Limites mises à jour (Mode Démo)' : 'Limites mises à jour');
    } catch (error) {
      console.error('Error:', error);
      toast.error('Erreur lors de la mise à jour des limites');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8">
      {isDemoMode && (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
          <div className="flex items-center">
            <Info className="text-yellow-400 mr-2" size={20} />
            <p className="text-yellow-700">
              Mode démo actif : Les changements seront sauvegardés localement uniquement
            </p>
          </div>
        </div>
      )}

      {/* Section Multiplicateurs */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <Zap className="text-yellow-500" />
          Multiplicateurs
        </h3>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 p-4 bg-yellow-50 rounded-lg">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Limite d'achat maximale
              </label>
              <input
                type="number"
                value={maxMultiplierPurchase}
                onChange={(e) => setMaxMultiplierPurchase(parseInt(e.target.value))}
                className={inputClasses}
                min="1"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section Auto-Clickers */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
          <MousePointer2 className="text-purple-500" />
          Auto-Clickers
        </h3>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4 p-4 bg-purple-50 rounded-lg">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Limite d'achat maximale
              </label>
              <input
                type="number"
                value={maxAutoClickerPurchase}
                onChange={(e) => setMaxAutoClickerPurchase(parseInt(e.target.value))}
                className={inputClasses}
                min="1"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-end pt-4">
        <button
          type="submit"
          className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded-lg transition-colors"
        >
          <Save size={20} />
          {isDemoMode ? 'Sauvegarder (Mode Démo)' : 'Mettre à jour les limites'}
        </button>
      </div>
    </form>
  );
}